import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideRouter } from '@angular/router'

import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http'
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client'
import { authConfig } from '../core/auth/auth.config'
import { routes } from './app.routes'

import { fr } from 'primelocale/js/fr.js'
import { providePrimeNG } from 'primeng/config'
import { AdminPreset } from '../styles/admin-preset'

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: AdminPreset,
        options: {
          darkModeSelector: false,
        },
      },
      translation: {
        ...fr,
      },
    }),
    provideAuth(authConfig),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor()])),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
  ],
}
